import { Box, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import React from "react";

export default function Prices({ data }) {
  return (
    <Box display="flex" justifyContent="center">
      <Typography
        variant="h6"
        fontWeight={600}
        color="text.main"
        paddingRight={0.5}
      >
        <NumberFormats value={data?.filled} />{" "}
      </Typography>

      <Typography
        variant="h6"
        fontWeight={400}
        color="text.main"
        paddingRight={0.5}
      >
        <NumberFormats value={data?.coinSourceName} /> /{" "}
      </Typography>
      <Typography
        variant="h6"
        fontWeight={600}
        color="text.main"
        paddingRight={0.5}
      >
        <NumberFormats value={data?.total} />{" "}
      </Typography>
      <Typography variant="h6" fontWeight={400} color="text.main">
        {data?.coinDestinationName}
      </Typography>
    </Box>
  );
}
